export interface FeatureCardProps {
  title: string
  description: string
  icon: string
  isSoon?: boolean
}

export const useFeatureCard = (props: FeatureCardProps) => {
  return {
    ...props,
  }
}
